import type { FormTarget, OrderAttribute } from "@jti/magento";
import { IOrderInputTypeEnum } from "@jti/magento";

import { useVisibleOrderAttributes } from "../../hooks";
import { CheckboxAttributeInput } from "../inputs/CheckboxAttributeInput";
import { TextAttributeInput } from "../inputs/TextAttributeInput";

import styles from "./OrderAttributesSlot.module.scss";

export type OrderAttributesSlotProps = { slotTarget: FormTarget };

const orderAttributeRendererRegistry = (attribute: OrderAttribute) => {
  switch (attribute.input_type) {
    case IOrderInputTypeEnum.Checkbox:
      return <CheckboxAttributeInput key={attribute.code} attribute={attribute} />;
    case IOrderInputTypeEnum.Text:
      return <TextAttributeInput key={attribute.code} attribute={attribute} />;
    default:
      return null;
  }
};

export const OrderAttributesSlot = ({ slotTarget }: OrderAttributesSlotProps) => {
  const { attributes, isLoading, isError, isEmpty } = useVisibleOrderAttributes(slotTarget);

  if (isLoading || isError || isEmpty) return null;

  return <div className={styles.orderAttributesSlotWrapper}>{attributes.map(orderAttributeRendererRegistry)}</div>;
};
